import {Component, ElementRef, EventEmitter, forwardRef, HostBinding, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectOption} from '@catuiform/types';
import {DomHandler} from 'primeng/primeng';

const componentBaseName = 'input-list';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-input-list',
  templateUrl: './input-list.component.html',
  styleUrls: ['./input-list.component.scss'],
})
export class InputListComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() title: string;
  @Input() values: SelectOption[];
  @Output() initChanged: EventEmitter<any> = new EventEmitter();

  constructor(public el: ElementRef) {
  }

  initChange() {
    this.initChanged.emit();
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/components/input-list/input-list.component.ts